import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation } from "@tanstack/react-query";

export const useCareerSimulationLoginCode = (simulationCode) => {
  const request = useApiRequest({
    url: `/career-simulations/${simulationCode}/login-code`,
    method: HttpMethod.Get,
  });

  // A mutation rather than a query so the classroom can be passed in at call
  // time, and so the code disappears when the user leaves the details page —
  // the observer starts idle again on the next mount.
  return useMutation({
    mutationKey: ["career-simulation-login-code", simulationCode],
    mutationFn: ({ classroomId } = {}) =>
      request({
        params: classroomId ? { classroom_id: classroomId } : undefined,
      }),
  });
};
